<template>
  <v-container>
    <v-row justify="center">
      <v-col sm="12" md="10">
        <v-tabs
          class="elevation-1"
          fixed-tabs
        >
          <v-tab
            v-for="item in tabs"
            :key="item.text"
            :to="{ name: item.name }"
          >
            {{ item.text }}
          </v-tab>
        </v-tabs>
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ZenKitHome",
  data() {
    return {
      tabs: [
        { text: 'Chemicals', name: 'ChemicalListView'},
        { text: 'Consumables', name: 'ConsumablesListViews'}
      ]
    }
  }
}
</script>
